import { TransactionServiceMock } from "@/services";

export const mockTransactionService = (): TransactionServiceMock => ({
  fetchTransactions: jest.fn(),
  fetchTransactionsFileExport: jest.fn(),
  fetchSearchConfig: jest.fn(),
  fetchDefaultFields: jest.fn(),
});
